import React, { useState } from 'react';
import UserList from './UserList';
import UserForm from './UserForm';
import UserPermissions from './UserPermissions';
import UserRoles from './UserRoles';
import { useAuth } from '../contexts/AuthContext';
import { usePageBreadcrumbs } from '../hooks/usePageBreadcrumbs';
import { resolveAdminPath } from '../utils/adminBreadcrumbUtils';

const UserManagement = () => {
  const { hasPermission } = useAuth();
  const adminPath = resolveAdminPath(hasPermission);
  const adminSegmentPath = (adminPath && adminPath !== '/users') ? adminPath : undefined;

  usePageBreadcrumbs([
    { label: 'Admin', path: adminSegmentPath },
    { label: 'Users' }
  ]);
  const [showForm, setShowForm] = useState(false);
  const [showPermissions, setShowPermissions] = useState(false);
  const [showRoles, setShowRoles] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateUser = () => {
    setEditingUser(null);
    setShowForm(true);
  };

  const handleEditUser = (user) => {
    setEditingUser(user);
    setShowForm(true);
  };

  const handleManagePermissions = (user) => {
    setEditingUser(user);
    setShowPermissions(true);
  };
  
  const handleManageRoles = (user) => {
    setEditingUser(user);
    setShowRoles(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingUser(null);
    setRefreshKey(prev => prev + 1);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingUser(null);
  };

  const handleClosePermissions = () => {
    setShowPermissions(false);
    setEditingUser(null);
  };
  
  const handleCloseRoles = () => {
    setShowRoles(false);
    setEditingUser(null);
  };

  return (
    <div className="user-management">
      {showForm ? (
        <UserForm
          user={editingUser}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      ) : showPermissions ? (
        <UserPermissions
          user={editingUser}
          onClose={handleClosePermissions}
        />
      ) : showRoles ? (
        <UserRoles
          user={editingUser}
          onBack={handleCloseRoles}
        />
      ) : (
        <UserList
          key={refreshKey}
          onEditUser={handleEditUser}
          onCreateUser={handleCreateUser}
          onManagePermissions={handleManagePermissions}
          onManageRoles={handleManageRoles}
        />
      )}
    </div>
  );
};

export default UserManagement;